module.exports = __webpack_public_path__ + "static/media/oAuth-Google.2d0d6fb5.svg";